module.exports = __webpack_public_path__ + "static/media/tanja-heffner-584869-unsplash.caefe0c5.jpg";